export default "__VITE_ASSET__771616ee__"